import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLayout, FiMobile, FiBell, FiAward, FiShoppingCart, FiCpu, FiServer } = FiIcons;

const Services = () => {
  const services = [
    { title: 'Custom websites', desc: 'Professional sites built to convert, not just to look finished.', icon: FiLayout },
    { title: 'Customer-facing apps', desc: 'Mobile apps for your customers, branded to you.', icon: FiMobile },
    { title: 'Push notifications built in', desc: 'One tap to every regular\'s phone. Free marketing that doesn\'t get throttled.', icon: FiBell },
    { title: 'Loyalty programs', desc: 'Punch cards, points, tiers — whatever fits your shop.', icon: FiAward },
    { title: 'Ordering and booking tools', desc: 'Online ordering, reservations, and scheduling.', icon: FiShoppingCart },
    { title: 'POS integration', desc: 'Where applicable, your app can talk to your point-of-sale.', icon: FiCpu },
    { title: 'Custom software', desc: 'Internal tools, dashboards, and workflows built around your operation.', icon: FiServer },
  ];

  return (
    <section className="py-24 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-20">
          <span className="text-[#3b82f6] font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Capabilities</span>
          <h2 className="text-4xl md:text-5xl font-black text-white tracking-tight uppercase font-montserrat">What we build for local businesses</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-[#2a3658] border border-[#344271] p-10 rounded-[32px] hover:border-[#3b82f6]/40 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-[#3b82f6]/10 rounded-2xl flex items-center justify-center mb-8 border border-[#3b82f6]/20">
                <SafeIcon icon={service.icon} className="text-2xl text-[#3b82f6]" />
              </div>
              <h3 className="text-xl font-black text-white mb-4 tracking-tight uppercase font-montserrat">{service.title}</h3>
              <p className="text-[#e2e8f0] leading-relaxed font-medium">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;